<script>
    import BaseListener from "@/assets/plugins/mps-common/event/base-listener";

    export default {
        name: "OnModalVuetifyOpenRequestListener",
        extends: BaseListener,
        created() {
            this.registerListener(this.mpsEvents.ON_MODAL_OPEN_REQUESTED, this.onModalOpenRequested);
        },
        beforeDestroy() {
            this.unregisterListener(this.mpsEvents.ON_MODAL_OPEN_REQUESTED, this.onModalOpenRequested);
        }
    }
</script>
